document.addEventListener("DOMContentLoaded", function () {
    const popup = document.getElementById('shop-closure-popup');

    // Check date
    const today = new Date();
    const cutoffDate = new Date('2025-10-28T00:00:00');
    const isClosed = today >= cutoffDate;
    if (isClosed) {
        popup.querySelector('.shop-closure-popup--still-closed').classList.remove('hidden');
    } else {
        popup.querySelector('.shop-closure-popup--still-open').classList.remove('hidden');
    }

    const closeHandler = () => {
        popup.classList.add('hidden');

        if (isClosed) {
            // Redirect to closed page
            window.location.href = 'https://www.jamesonwhiskey.com/en';
        }
    }

    // Close
    popup.querySelector('.shop-closure-popup--overlay').addEventListener('click', closeHandler);
    popup.querySelector('.shop-closure-popup--close').addEventListener('click', closeHandler);
    popup.querySelector('#close-popup-btn').addEventListener('click', closeHandler);

    // Show popup
    popup.classList.remove('hidden');
});
